import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { Heading2 } from '../../../components/Text';

import style from '../section.module.css';

interface Props {
  className?: string;
}

const SectionTitle = ({
  children,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <Heading2
      className={classNames(style.sectionTitle, className)}
      fontSizeOverride={38}
      fontWeight={300}
    >
      {children}
    </Heading2>
  );
};

export default SectionTitle;
